import { render, staticRenderFns } from "./assignment-approver.vue?vue&type=template&id=3ff425bb"
import script from "./assignment-approver.vue?vue&type=script&lang=js"
export * from "./assignment-approver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports